import { Link, type LinkProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export type RouteLinkProps = LinkProps<typeof RouterLink>;

/** @deprecated Prefer `~ui/atoms/Link/Link` with `variant="internal" */
export const RouteLink = ({ children, ...props }: RouteLinkProps) => {
  return (
    <Link component={RouterLink} {...props}>
      {children}
    </Link>
  );
};
